// extracted by mini-css-extract-plugin
export default {"cls1":"uw96SPJ8ifonxsBIX0Or","cls2":"SVJvW3wenXOaZefXbPTP uw96SPJ8ifonxsBIX0Or","isInvalid":"fHr064F0AeQgYQ3TzPpz"};